enum Reducers {
  UI = 'ui',
  Auth = 'auth',
  Quiz = 'quiz',
  Question = 'question',
  Player = 'player',
  Rokt = 'rokt',
  Consent = 'consent',
  Pages = 'pages',
  QuizEvents = 'quizEvents'
};

export default Reducers;
